import { Component, OnDestroy, OnInit, TemplateRef, NgZone } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { Observable, Subscription, Observer } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SecurityService, LoaderService, PortalService, CoreService, AuthorizationService, UserService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { IPortalNavigation, PlatForm, IPortalConfig, Tools, IUserInfo } from 'src/app/models';
import { NgbOffcanvas, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Helpers } from 'src/app/helpers';
import _ from 'lodash';
import { NavigatesearchService } from 'src/app/services/navigatesearch.service';
import { FormControl, FormGroup } from '@angular/forms';
import { OrderByPipe } from 'ngx-pipes';
import { Title } from '@angular/platform-browser';
import { Constants } from 'src/app/shared/models/constants';

interface RaiNavChildItem {
  label: string;
  menuCode: string;
  featureCode: string;
  route: string;
  displayOrder?: number;
}

interface RaiNavItem extends RaiNavChildItem {
  icon: string;
  expanded?: boolean;
  expandOnly?: boolean;
  children: RaiNavChildItem[];
}

const DEFAULT_RAI_ICON = 'fa-circle-o';
const DEFAULT_RAI_ROUTE = 'AI';

@Component({
  selector: 'medpt-rai-header',
  templateUrl: './rai-header.component.html',
  styleUrls: ['./rai-header.component.scss'],
  providers: [OrderByPipe],
  standalone: false
})
export class RaiHeaderComponent implements OnInit, OnDestroy {
  searchText: string = '';
  myGroup = new FormGroup({
    searchText: new FormControl()
  });

  secureAppUrl = environment.SSO.secureAppUrl;
  myAppUrl = environment.myAppUrl;
  AdminAppUrl = Helpers.getAdminAppUrl();
  AppUrl = Helpers.getApplicationUrl();
  HeaderBrandingIconPath = Helpers.getPlatformLogo();
  cdnEndPoint = environment.cdnEndPoint;

  isPortalNavVisibled: Observable<boolean> = new Observable((ob: Observer<boolean>) => { ob.next(false); });
  isPortalToolVisibled: Observable<boolean> = new Observable((ob: Observer<boolean>) => { ob.next(false); });
  portalDisplayName: Observable<string> = new Observable((ob: Observer<string>) => { ob.next(''); });
  toolsMenu: Observable<Array<Tools>> = new Observable((ob: Observer<Array<Tools>>) => { ob.next([]); });
  navigationMenu: Array<IPortalNavigation> = [];
  portalLogo: Observable<string> = new Observable((ob: Observer<string>) => { ob.next(''); });

  raiNavItems: RaiNavItem[] = [];
  readonly raiHomeRoute = Constants.RASPberryAI_HOME_ROUTE;

  portalName = '';
  sponsorName = '';
  portalList: Array<IPortalConfig> = [];
  filteredPortalList: Array<IPortalConfig> = [];

  isMobileMode = false;
  isSidebarOpen = false;
  isSidebarCollapsed = false;
  isDashboard = false;
  private previousViewportWidth = 0;
  private userToggledCollapse = false;
  portallistopened = false;
  isAiPanelOpen = false;
  isAIEnabled = false;
  isRaspberryAIFeatureSelected = false;
  userDisplayName: string = '';
  userRole: string = '';

  private portalNameSubscription!: Subscription;
  private showPortalSectionSubscription!: Subscription;
  private toolsMenuSubscription!: Subscription;
  private navigationMenuSubscription!: Subscription;
  private portalConfigSubscription!: Subscription;
  private routerSubscription!: Subscription;
  private featuresSubscription!: Subscription;

  private readonly viewportChange = this.viewportRuler.change(200).subscribe(() => this.ngZone.run(() => this.onScreenResize()));

  constructor(
    private securityService: SecurityService,
    public portalService: PortalService,
    public activatedRouter: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private offcanvasService: NgbOffcanvas,
    private readonly viewportRuler: ViewportRuler,
    private readonly ngZone: NgZone,
    private navigatesearchService: NavigatesearchService,
    private coreService: CoreService,
    private authorizationService: AuthorizationService,
    private titleService: Title,
    private userService: UserService
  ) {
    this.isDashboard = this.router.url.toLowerCase() === '/dashboard';
    this.routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Close mobile sidebar on navigation
        this.isSidebarOpen = false;
        this.isDashboard = this.router.url.toLowerCase() === '/dashboard';
        this.updateAiToggleVisibility();
        this.expandActiveParentNavItem();
      }
    });

    this.portalNameSubscription = this.portalService
      .getPortalDisplayName()
      .subscribe((title: string) => {
        this.portalDisplayName = new Observable((ob: Observer<string>) => { ob.next(title); });
      });

    this.showPortalSectionSubscription = this.portalService
      .getShowPortalSection()
      .subscribe((showPortalSection: boolean) => {
        this.isPortalNavVisibled = new Observable((ob: Observer<boolean>) => { ob.next(showPortalSection); });
      });

    this.toolsMenuSubscription = this.portalService
      .getToolsMenuSubject()
      .subscribe((toolsMenu: Array<Tools>) => {
        toolsMenu.forEach((item) => {
          item.AdminToolSubMenu = _.orderBy(item.AdminToolSubMenu, ['SubMenuDisplayName'], ['asc']);
          item.AdminToolSubMenu.forEach((subitem) => {
            if (subitem.SubMenuUrl.charAt(0) != '/') {
              subitem.SubMenuUrl = '/' + subitem.SubMenuUrl;
            }
          });
        });

        let isPortalToolVisibled = false;
        if (toolsMenu.length == 2)
          isPortalToolVisibled = toolsMenu[0].AdminToolSubMenu.length > 0 || toolsMenu[1].AdminToolSubMenu.length > 0;
        else if (toolsMenu.length == 1)
          isPortalToolVisibled = toolsMenu[0].AdminToolSubMenu.length > 0;

        this.isPortalToolVisibled = new Observable((ob: Observer<boolean>) => { ob.next(isPortalToolVisibled); });
        if (isPortalToolVisibled)
          this.toolsMenu = new Observable((ob: Observer<Array<Tools>>) => { ob.next(toolsMenu); });
      });

    this.navigationMenuSubscription = this.portalService
      .getNavigationMenuSubject()
      .subscribe((navigation: IPortalNavigation[]) => {
        this.navigationMenu = _.cloneDeep(navigation || []);
        this.buildRaiNavItems();
        this.updateAiToggleVisibility();
      });

    this.portalConfigSubscription = this.portalService
      .getPortalConfigSubject()
      .subscribe((config: IPortalConfig) => {
        this.portalName = config.PortalName!;
        this.sponsorName = config.SponsorName!;
        this.loadUserRole();
        if (config.IsStartupEnabled) {
          this.HeaderBrandingIconPath = environment.cdnEndPoint + '/medpointapps/img/AppLogos/TriPort_Startup_color.svg';
        } else {
          this.HeaderBrandingIconPath = Helpers.getPlatformLogo();
        }

        if (config.ClientLogo != '') {
          this.portalLogo = new Observable((ob: Observer<string>) => { ob.next(this.cdnEndPoint + '/' + config.ClientLogo); });
        }

        // sponsorName/portalName just became available, so re-check which parent should be expanded.
        this.expandActiveParentNavItem();
      });

    this.coreService.getUserPortals()
      .then((portals: Array<IPortalConfig>) => {
        _.each(portals, (item: IPortalConfig) => {
          _.each(item.Portals, (childitem: IPortalConfig) => {
            this.portalList.push(childitem);
          });
        });
        this.portalList = _.orderBy(this.portalList, ['DisplayName'], ['asc']);
        this.filteredPortalList = this.portalList;
      }).catch(() => { });

    // Recompute AI availability whenever the user's portal features load/change.
    // Features are populated asynchronously, so reading the value only once in
    // ngOnInit can miss them and leave the AI toggle permanently hidden.
    this.featuresSubscription = this.portalService.allUserPortalFeatures
      .subscribe(() => {
        this.isAIEnabled = this.authorizationService.isNavigationOrFeatueAllowed(Constants.RASPberryAI_CHATBOT_FEATURE_NAME);
      });
  }

  ngOnInit(): void {
    this.onScreenResize();
    document.body.classList.add('rai-layout-active');

    // Custom page title & favicon for RAI
    this.titleService.setTitle('RASPberry AI Trial Hub');
    const favIcon = document.querySelector('#appIcon') as HTMLLinkElement;
    if (favIcon) {
      favIcon.href = environment.cdnEndPoint + '/triport/icons/RaspberryAI.ico';
    }

    // Check if AI chatbot is enabled for this user
    this.isAIEnabled =  this.authorizationService.isNavigationOrFeatueAllowed(Constants.RASPberryAI_CHATBOT_FEATURE_NAME);
    this.updateAiToggleVisibility();

    // Load user info for display name
    const currentUser = this.securityService.currentUserValue;
    if (currentUser?.UserID) {
      this.userService.GetUserInfo(currentUser.UserID).then((userInfo: IUserInfo) => {
        const parts: string[] = [];
        if (userInfo.Salutation) { parts.push(userInfo.Salutation); }
        if (userInfo.FirstName) { parts.push(userInfo.FirstName); }
        if (userInfo.LastName) { parts.push(userInfo.LastName); }
        let displayName = parts.join(' ');
        if (userInfo.Title) { displayName += (displayName ? ', ' : '') + userInfo.Title; }
        this.userDisplayName = displayName;
      }).catch(() => { });
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('rai-layout-active');
    document.body.classList.remove('rai-sidebar-collapsed');
    document.body.classList.remove('rai-ai-panel-open');
    this.viewportChange.unsubscribe();
    if (this.portalNameSubscription) this.portalNameSubscription.unsubscribe();
    if (this.showPortalSectionSubscription) this.showPortalSectionSubscription.unsubscribe();
    if (this.toolsMenuSubscription) this.toolsMenuSubscription.unsubscribe();
    if (this.navigationMenuSubscription) this.navigationMenuSubscription.unsubscribe();
    if (this.portalConfigSubscription) this.portalConfigSubscription.unsubscribe();
    if (this.routerSubscription) this.routerSubscription.unsubscribe();
    if (this.featuresSubscription) this.featuresSubscription.unsubscribe();

    // Restore default title & favicon
    const favIcon = document.querySelector('#appIcon') as HTMLLinkElement;
    if (favIcon) {
      favIcon.href = Helpers.getPlatformIcon();
    }
    this.titleService.setTitle(Helpers.getPlatformName());
  }

  onScreenResize(): void {
    const { width } = this.viewportRuler.getViewportSize();
    this.isMobileMode = width < 900;
    if (!this.isMobileMode) {
      this.isSidebarOpen = false;
    }
    // Auto-collapse sidebar only when crossing INTO the tablet range (768–1024px)
    // from a wider desktop layout (or on first load), AND only when the user has
    // not manually toggled the sidebar. Without the manual-toggle guard the
    // sidebar snaps back to collapsed right after the user expands it: expanding
    // reflows content and toggles the document scrollbar, which fires another
    // resize event whose width can dip back below 1024px. That is why the nav
    // labels failed to appear when the browser was zoomed (e.g. 125%).
    const isTablet = width >= 768 && width <= 1024;
    const cameFromWiderLayout = this.previousViewportWidth === 0 || this.previousViewportWidth > 1024;
    if (isTablet && cameFromWiderLayout && !this.userToggledCollapse) {
      this.isSidebarCollapsed = true;
      this.portallistopened = false;
    }
    this.previousViewportWidth = width;
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  toggleAiPanel(): void {
    this.isAiPanelOpen = !this.isAiPanelOpen;
    document.body.classList.toggle('rai-ai-panel-open', this.isAiPanelOpen);
  }

  closeAiPanel(): void {
    this.isAiPanelOpen = false;
    document.body.classList.remove('rai-ai-panel-open');
  }

  toggleSidebarCollapse(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    this.userToggledCollapse = true;
    this.portalService.setRaiNavCollapsed(this.isSidebarCollapsed);
    document.body.classList.toggle('rai-sidebar-collapsed', this.isSidebarCollapsed);
  }

  onSearch(event: any): void {
    const searchVal = this.myGroup.controls['searchText'].value;
    if (searchVal != undefined && searchVal != null && searchVal != '') {
      this.navigatesearchService.setSearchString(searchVal);
      this.router.navigate(['Search'], { relativeTo: this.activatedRouter, queryParams: { q: searchVal } });
      this.closeSidebar();
    }
  }

  openSearchWindow(content: TemplateRef<any>): void {
    this.offcanvasService.open(content, { position: 'top', panelClass: 'search-canvas', scroll: true });
  }  

  over(drop: NgbDropdown): void {
    drop.open();
  }

  out(drop: NgbDropdown): void {
    drop.close();
  }

  openFeedback(): void {
    // Trigger the global feedback bot by clicking its icon programmatically
    const feedbackBtn = document.querySelector('.righticons-bar .bot-chat') as HTMLElement;
    if (feedbackBtn) {
      feedbackBtn.click();
    }
  }

  logout(): void {
    this.loaderService.showLoader();
    setTimeout(() => { this.securityService.logout(); });
  }

  applyFilter(event: any): void {
    this.filteredPortalList = this.portalList.filter((item: any) => {
      return item.DisplayName.toString().toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
    });
  }

  getRaiRoute(route: string): string {
    if (!this.sponsorName || !this.portalName) return '';
    return `/Go/${this.sponsorName}/${this.portalName}/${route}`;
  }

  // Route matching is case-insensitive (see CaseInsensitiveMatcher) so highlighting must be too.
  isRouteActive(targetRoute: string): boolean {
    return !!targetRoute && this.normalizeRoute(this.router.url) === this.normalizeRoute(targetRoute);
  }

  toggleSubmenu(item: { expanded?: boolean }): void {
    item.expanded = !item.expanded;
  }

  private loadUserRole(): void {
    if (!this.sponsorName || !this.portalName) { return; }
    this.coreService.getUserPortalInfo(this.sponsorName, this.portalName)
      .then((portalInfo: IPortalConfig) => {
        this.userRole = portalInfo?.RoleName ?? '';
      })
      .catch(() => { });
  }

  private updateAiToggleVisibility(): void {
    const selectedFeatureId = this.getSelectedFeatureIdFromRoute(this.router.url);
    this.isRaspberryAIFeatureSelected = selectedFeatureId === Constants.RASPberryAI_FEATURE_ID
      || this.router.url
        .split('/')
        .filter(Boolean)
        .pop()
        ?.toLowerCase() === 'raspberryai';
    if (this.isRaspberryAIFeatureSelected && this.isAiPanelOpen) {
      this.closeAiPanel();
    }
  }

  private getSelectedFeatureIdFromRoute(url: string): number | null {
    const normalizedRoute = this.normalizeRoute(url);

    for (const item of this.raiNavItems) {
      const itemRoute = this.getRaiRoute(item.route);
      if (itemRoute && this.normalizeRoute(itemRoute) === normalizedRoute) {
        return Number(item.featureCode) || Number(item.menuCode) || null;
      }

      const matchedChild = (item.children || []).find((child) => {
        const childRoute = this.getRaiRoute(child.route);
        return childRoute && this.normalizeRoute(childRoute) === normalizedRoute;
      });

      if (matchedChild) {
        return Number(matchedChild.featureCode) || Number(matchedChild.menuCode) || null;
      }
    }

    return null;
  }

  private normalizeRoute(url: string): string {
    const routeWithoutQueryOrFragment = (url || '').split('?')[0].split('#')[0];
    const normalized = routeWithoutQueryOrFragment.replace(/\/+$/, '').toLowerCase();
    return normalized || '/';
  }

  private buildRaiNavItems(): void {
    if (Helpers.getPlatformId() !== PlatForm.RaspberryAI) {
      return;
    }

    const mappedItems = (this.navigationMenu || []).map((navigation) => this.createRaiNavItem(navigation));
    this.raiNavItems = this.sortRaiNavItems(mappedItems);
    this.expandActiveParentNavItem();
  }

  // Auto-expand the parent whose child route matches the current URL, so a direct link to a child page is visible.
  private expandActiveParentNavItem(): void {
    const activeParent = this.raiNavItems.find((item) =>
      (item.children || []).some((child) => this.isRouteActive(this.getRaiRoute(child.route)))
    );
    if (activeParent) {
      activeParent.expanded = true;
    }
  }

  private createRaiNavItem(navigation: IPortalNavigation): RaiNavItem {
    const fallbackRoute = this.getDefaultRoute(navigation);
    const children = navigation._FeatureID === Constants.RASPberryAI_FEATURE_ID
      ? []
      : this.sortRaiNavItems(
        (navigation.ChildFeatures || []).map((childNavigation) => this.createRaiNavChildItem(childNavigation, navigation))
      );

    return {
      label: navigation.DisplayName || this.getRaiNavigationLabel(fallbackRoute),
      menuCode: navigation._FeatureID.toString(),
      featureCode: navigation.FeatureName || navigation._FeatureID.toString(),
      icon: navigation.Icon || DEFAULT_RAI_ICON,
      route: fallbackRoute,
      displayOrder: this.getDisplayOrder(navigation),
      expandOnly: children.length > 0,
      children
    };
  }

  private createRaiNavChildItem(navigation: IPortalNavigation, parentNavigation: IPortalNavigation): RaiNavChildItem {
    const fallbackRoute = this.getDefaultRoute(navigation, parentNavigation);

    return {
      label: navigation.DisplayName || this.getRaiNavigationLabel(fallbackRoute),
      menuCode: navigation._FeatureID.toString(),
      featureCode: navigation.FeatureName || navigation._FeatureID.toString(),
      route: fallbackRoute,
      displayOrder: navigation.Ordinal ?? Number.MAX_SAFE_INTEGER
    };
  }

  private getDisplayOrder(navigation?: IPortalNavigation): number {
    if (navigation?.RAIDisplayOrder !== undefined && navigation?.RAIDisplayOrder !== null && !isNaN(Number(navigation.RAIDisplayOrder))) {
      return Number(navigation.RAIDisplayOrder);
    }
    if (navigation?.Ordinal !== undefined && navigation?.Ordinal !== null && !isNaN(Number(navigation.Ordinal))) {
      return Number(navigation.Ordinal);
    }
    return Number.MAX_SAFE_INTEGER;
  }

  private sortRaiNavItems<T extends { displayOrder?: number; label?: string }>(items: T[]): T[] {
    return [...(items || [])].sort((left, right) => {
      const orderA = left.displayOrder ?? Number.MAX_SAFE_INTEGER;
      const orderB = right.displayOrder ?? Number.MAX_SAFE_INTEGER;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return (left.label || '').localeCompare(right.label || '');
    });
  }

  private getDefaultRoute(navigation: IPortalNavigation, parentNavigation?: IPortalNavigation): string {
    // RASPberryAI's own route must differ from the Home link, which targets the dedicated Home route.
    // otherwise both sidebar items highlight as active together.
    if (navigation._FeatureID === Constants.RASPberryAI_FEATURE_ID) {
      return Constants.RASPberryAI_FEATURE_NAME;
    }
    const featureName = navigation.FeatureName || DEFAULT_RAI_ROUTE;
    return parentNavigation?.FeatureName ? `${parentNavigation.FeatureName}/${featureName}` : featureName;
  }

  private getRaiNavigationLabel(route: string): string {
    const routePart = (route || DEFAULT_RAI_ROUTE).split('/').filter((part) => part).pop() || DEFAULT_RAI_ROUTE;
    return routePart
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/AI/g, 'AI')
      .replace(/FAQ/g, 'FAQ');
  }
}
